import { Fragment, useCallback, useState, useEffect, useRef } from "react";
import Good from "./type/Good";
import general, { redux } from "../../general";
import KeepScroll from "../../lib/KeepScroll";
import $ from "jquery";
import Dialog from "../../lib/Dialog";
import { useMount } from "ahooks";
import Type from "./type/Type";
import useRequest from "../../lib/useRequest";
import { storageLocal } from "../util/storage";
import { useLocation } from "react-router-dom";

export default (props) => {
  const location = useLocation();

  // 分类侧边栏选中项
  let [tag, setTag] = useState("");
  const [isShow, setIsShow] = useState(false);
  const typesRef = useRef(null);
  const mainsRef = useRef(null);
  const { data: tags } = useRequest(
    async () => {
      Dialog.loading();
      return general.axios
        .get("/v3/base/appcategorize/getAppCategorize")
        .finally(() => Dialog.close())
        .then(({ data: resData }) => {
          console.log("分类列表", resData);

          if (!resData.status.succeed) {
            Dialog.error(resData.status.error_desc);
            return false;
          }

          if (resData.data && resData.data.length > 0 && !tag) {
            setTag(resData.data[0].id);
          }

          setIsShow(true);
          return resData.data;
        })
        .catch((error) => Dialog.error(error.message));
    },
    { cacheKey: "game-tags" },
  );

  const tagRef = useCallback((node) => {
    if (node) {
      if (
        node.parentNode.scrollTop + node.parentNode.offsetHeight <
          node.offsetTop ||
        node.parentNode.scrollTop +
          node.parentNode.offsetHeight +
          node.offsetHeight >
          node.offsetTop
      ) {
        $(node.parentNode).animate(
          { scrollTop: node.offsetTop - node.parentNode.offsetHeight / 2 },
          555,
        );
        node.parentNode.scrollTop =
          node.offsetTop - node.parentNode.offsetHeight / 2;
      }
    }
  }, []);

  useMount(() => {
    if (general.tag) {
      tag = general.tag;
      setTag(general.tag);

      $("html,body").scrollTop(0);
    }

    redux.subscribe(() => {
      let tag2 = redux.getState().screenRouter?.tag;

      if (tag2) {
        tag = tag2;
        setTag(tag2);

        $("html,body").scrollTop(0);
      }
    });
    console.log("传递tag----------------", tag);
  });

  const dataGet = (data) => {
    if (tags && tags.length > 0) {
      for (let i = 0; i < tags.length; i++) {
        if (tags[i].id == data) {
          return 6;
        }
      }
    }
  };

  useEffect(() => {
    let num2 = dataGet(tag);
    if (!num2) {
      if (tags && tags.length > 0) {
        setTag(tags[0].id);
      }
    }
  }, [tag]);

  // 切换分类时右侧滚动区域滚回顶部（右侧已是独立滚动容器，不再用 body）
  useEffect(() => {
    if (mainsRef.current) mainsRef.current.scrollTop = 0;
  }, [tag]);

  // 分类页：锁定 body 不滚动，左侧/右侧在各自固定区域内滚动，从根上避免 iOS 滑左侧误滚右侧
  useEffect(() => {
    if (location.pathname === "/screen-game") {
      if (!isShow || !tag) return;
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    } else {
      document.body.style.overflow = "";
    }
  }, [isShow, tag, location.pathname]);

  return (
    <div className="game-index-type">
      {isShow && tag && (
        <div>
          {/* 分类左侧导航栏 */}
          <div
            className="types"
            style={{
              paddingBottom: storageLocal.has("kfUrl") ? "60px" : "0",
            }}
            ref={typesRef}
          >
            {tags &&
              tags.length > 0 &&
              tags?.map((item, index) => (
                <Fragment key={index}>
                  <div
                    className={"type " + (tag == item.id ? "active" : "")}
                    onClick={() => {
                      setTag(item.id);
                    }}
                    ref={tag == item.id ? tagRef : null}
                  >
                    {item.title}
                  </div>
                </Fragment>
              ))}
          </div>

          {/* 右侧对应数据展示（固定高度独立滚动，避免与左侧抢手势） */}
          <div className="mains" ref={mainsRef}>
            <Fragment>
              {tags &&
                tags.length > 0 &&
                tags?.map((item) => {
                  let active = props.active && item.id == tag;
                  return (
                    <KeepScroll key={item.id} active={active} lazy>
                      <div className={`main ${active ? "active" : ""}`}>
                        {item.pagetype == 1 ? (
                          <>
                            <Good active={active} tag={tag} mainsRef={mainsRef} />
                          </>
                        ) : (
                          <>
                            <Type
                              active={active}
                              tag={tag}
                              pagetype={item.pagetype}
                              mainsRef={mainsRef}
                            />
                          </>
                        )}
                      </div>
                    </KeepScroll>
                  );
                })}
            </Fragment>
          </div>
        </div>
      )}
    </div>
  );
};
